import { getApiBaseUrl } from '../../../shared/utils/apiBase';

type SessionFeatureAccessResponse = {
  data?: {
    access?: boolean;
  };
};

/**
 * Resolves whether the current cookie-authenticated session has access to a feature
 * for the given screen grid.
 *
 * @param screenGridId Screen grid identifier used by server-side feature access checks.
 * @returns `true` or `false` when access is resolved, otherwise `null` when
 * the lookup is not reliable (request failure, non-OK response, or invalid payload).
 */
export async function resolveSessionFeatureAccess(
  screenGridId: number,
): Promise<boolean | null> {
  try {
    const apiBase = getApiBaseUrl();
    const params = new URLSearchParams({
      screenGridId: String(screenGridId),
    });

    const response = await fetch(`${apiBase}/api/sessionFeatureAccess?${params.toString()}`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      return null;
    }

    const result = (await response.json()) as SessionFeatureAccessResponse;

    return result?.data?.access ?? null;
  } catch {
    return null;
  }
}
